import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled, { css } from 'styled-components'
import { NavLink, withRouter } from 'react-router-dom'
import { VelocityComponent } from 'velocity-react'
import { filter } from 'lodash'

import { data } from './data'
import { sections } from '../../data/sections'
import { isAuthenticated } from '../../auth'

import { fetchSettings, getSettings, updateSettings } from '../../settings'
import { fetchChapters, getChapters } from '../../modules/Chapters/redux'

import { media, newMedia } from '../../styles/utils'
import { container, bgImage, bgIcon, padding, hoverState } from '../../styles/global'

import Logo from 'svg-react-loader?name=Icon!../../assets/images/aesop-logo.svg'


class Sidebar extends Component {

    state = {
        pageLoaded: false,
        menuActive: false,
        contentsVisible: false,
    }

    static fetchData(store, match) {
        return store.dispatch(fetchChapters()); 
    }

    componentDidMount() {
        this.props.fetchSettings();
        this.props.fetchChapters();
        //console.log(this.props.match.params.slug)
    }
    
    componentDidUpdate = (prevProps, prevState) => {
        const { settings } = this.props;

        if (prevProps.settings.searchActive !== settings.searchActive && settings.searchActive) {
            this.setState({
                contentsVisible: false
            })
        }
    }
    
    isChapterActive = (section, slug) => {
        const { settings } = this.props;
        if (settings.activeChapter.section == section && settings.activeChapter.slug == slug) return true
    }

    toggleContents = () => {
        this.setState({
            contentsVisible: !this.state.contentsVisible
        })
    }

    renderSections = () => {
        const { chapters } = this.props;

        if (chapters.data) {
            return chapters.data.map((section, i) => {

                if (section.type === 'parent') {

                    // get child pages related to current section/parent page

                    const children = filter(this.props.chapters.data, { parent_id: section.id })
                    const chapters = children.map((chapter, i) => {
                        return (
                            <ChapterLink
                                key={i}
                                to={`/chapter/${section.slug}/${chapter.slug}`}
                                active={this.isChapterActive(section.slug, chapter.slug)}
                            >
                                {chapter.title}
                            </ChapterLink>
                        )
                    })
    
                    if (children.length) {
                        return (
                            <React.Fragment
                                key={i}
                            >
                                <SectionLink
                                    to={`/chapter/${section.slug}/${children[0].slug}`}
                                    hasChapters={true}
                                >
                                    {section.title}     
                                </SectionLink>
                            
                                <Chapters>
                                    {chapters}
                                </Chapters>
                            </React.Fragment>
                        )
                    }
                }
            })
       }   
    }
    
    renderContents = () => {
        const { contentsVisible } = this.state;

        return (
            <React.Fragment>
                <ContentsHeader
                    active={contentsVisible}
                    onClick={this.toggleContents} 
                >
                    Aesop Store Design
                </ContentsHeader>

                <ContentsIndex
                    visible={contentsVisible}
                >
                    <SectionLink
                        to={'/'}
                        activeClassName={'isActive'}
                        exact
                    >
                        Contents    
                    </SectionLink>

                    {this.renderSections()}
                    
                </ContentsIndex>
            </React.Fragment>
        )
    }

    renderNav = () => {    
        const items = data.navItems.map((item, i) => {
            return (
                <NavItem
                    key={i}
                    to={item.link}
                >
                    {item.label}
                </NavItem>  
            )
        })

        return (
            <Nav>
                {items}
            </Nav>
        )
    }

    render() {
        const { pageLoaded } = this.state;
        const { location, settings } = this.props;

        // Hide on login page
        
        return (
            <Container
                display={settings.isAuthenticated}
            >
                <Wrapper>
                    {this.renderContents()}
                    {this.renderNav()}
                
                    {/* todo: api data -  global_options.nav_support_text */}
                    <Help>
			For assistance with this document please <a href="mailto:Giselle.Hernandez@aesop.com">contact</a> Giselle Hernandez, Retail Design Project Manager or email <a href="mailto:store.design@aesop.com">store.design@aesop.com</a>
		    </Help>

                    <AesopLogo/>
                </Wrapper>
            </Container>
        )
    }
}

const Container = styled.div`
    ${container}
    max-width: none;
    display: ${props => props.display ? 'flex' : 'none'};
    flex-direction: column;
    flex: 0 1 360px;
    box-sizing: border-box;
    border-left: 1px solid black;
    overflow-y: scroll;
    max-height: calc(100vh - 65px); 

    ${media.phone`
        display: none;  
    `}
`

const Wrapper = styled.div`
    flex: 1;
    height: 100%;
`

const navItem = css`
    font-size: 24px;
    color: black;
    height: 57px;
    min-height: 57px;
    border-bottom: 1px solid black;
    ${padding}
    flex: 1 0 57px;

    display: flex;
    justify-content: flex-end;
    align-items: center;    

    user-select: none;
    cursor: pointer;
    transition: background 0.1s ease;

    &.active {
        background: #EBEADE;
    }

    &:hover {
        background: #EBEADE;
    }
`

// Contents title

const ContentsHeader = styled.div`
    ${navItem}
`

const ContentsIndex = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;    
    padding: 0 14px;
    padding-top: 6px;
    display: ${props => props.visible ? 'flex' : 'none'};
    border-bottom: 1px solid black;
    overflow-y: scroll;
`

const contentsLink = css`
    font-family: 'Suisse';
    font-size: 16px;
    color: #000000;
    text-align: right;

    /* Active style */

    &.isActive {
        text-decoration: underline;
        cursor: pointer;
    }

    ${props => {
        if (props.isActive == true) return css`
            text-decoration: underline;
        `
    }}
`

const SectionLink = styled(NavLink)`
    ${contentsLink}
    text-transform: uppercase;

    ${props => {
        if (!props.hasChapters) return css`
            cursor: pointer;
            ${hoverState}
            margin-bottom: 16px;
        `
    }}
`

const Chapters = styled.div`
    margin-bottom: 24px;
    display: flex;
    flex-direction: column;
    flex: 1 0 auto;
    align-items: flex-end;
`

const ChapterLink = styled(NavLink)`
    ${contentsLink}
    cursor: pointer;
    ${hoverState}
    position: relative;

    ${props => {
        if (props.active) return css`
            &::after {
                position: absolute;
                content: '';
                left: 0;
                right: 0;
                bottom: 0;
                border-bottom: 1px solid black;
                padding-bottom: 2px;
            }
        `
    }}
`

// Nav

export const Nav = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`

export const NavItem = styled(NavLink)`
    ${navItem}
`

// Nav

const Help = styled.div`
    font-size: 12px;
    color: #000000;
    text-align: right;
    margin-top: 6px;
    padding: 0 10px;

    a {
        text-decoration: underline;
    }
`;

const AesopLogo = styled(Logo)`
    align-self: flex-end;
    margin-top: 53px;
    padding-right: 13px;
    margin-left: auto;  
    display: block;
`;

const mapDispatchToProps = dispatch => ({
    fetchChapters() {
        dispatch(fetchChapters())
    },
    fetchSettings() {
        dispatch(fetchSettings())
    },
    updateSettings(setting) {
        dispatch(updateSettings(setting))
    },
})

const mapStateToProps = (state, props) => ({
    chapters: getChapters(state),
    settings: getSettings(state)
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Sidebar));



// WEBPACK FOOTER //
// ./client/components/Sidebar/Sidebar.js